<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "FAQs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "FAQs",
            items: [
               {
                  text: "FAQs",
                  active: true,
               },                   
            ],

            faqs: [],
            faq: {
               id: null,
               question : "",
               answer: "",
            },
            
            modal_title: "Add FAQ",
            button_title: "Save",
            pagination: {},
            edit: false,
            faq_status: {
               id: "",
               status: "",
            },
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchFAQs();
      },

      methods: {

         fetchFAQs(page_url = null) {

            this.getToken();
            let url = "api/admin/faq/index?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.faqs = responseData.faq.data;
                  
                  this.pagination = responseData.faq.links;
                  this.from = responseData.faq.from;
                  this.to = responseData.faq.to;
                  this.total = responseData.faq.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editFAQ(faq) {            
            this.modal_title = "Edit FAQ";
            this.button_title = "Update";
            this.faq.id = faq.id;
            this.faq.question = faq.question; 
            this.faq.answer = faq.answer;  
            this.edit = true;
            this.showModal("faq-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add FAQ";
            this.button_title = "Save";
            this.faq.id = "";
            this.faq.question = "";           
            this.faq.answer = "";           
            this.edit = false;

            this.errors = {};
         },

         addFAQ() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/faq/create";
               this.active_page_url = null;

            } else {
               url = "api/admin/faq/update";
               formData.append("id", this.faq.id); 
            }         

            formData.append("question", this.faq.question); 
            formData.append("answer", this.faq.answer); 

            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('faq-modal');
                  this.fetchFAQs(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         activateFAQ(faq) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this FAQ?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.faq_status.id = faq.id;
                  this.faq_status.status = 1;
                  this.updateFAQStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateFAQ(faq) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this FAQ?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.faq_status.id = faq.id;
                  this.faq_status.status = 2;
                  this.updateFAQStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateFAQStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };     

            var data = JSON.stringify({
               "id": this.faq_status.id,
               "status": this.faq_status.status
            });

            let url = "api/admin/faq/status";
            this.$axios
               .put(url, data, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchFAQs(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.faq-modal variant="primary" class="float-end">Add FAQ</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchFAQs()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchFAQs()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchFAQs()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>
                              <th>Question</th> 
                              <th>Answer</th>   
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(faqs.length)">
                           <tr v-for="(faq, index) in faqs" :key="faq.id">
                              <td>{{index + from}}</td>
                              <td>{{faq.question}}</td>
                              <td>{{faq.answer | excerpt(50)}}</td>
                              <td>{{faq.converted_created_at}}</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm me-2 mt-2" @click="editFAQ(faq)">Edit</b-button>

                                 <b-button v-if="faq.status==1" variant="danger" class="btn-sm mt-2 me-2" @click="deactivateFAQ(faq)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mt-2 me-2" @click="activateFAQ(faq)">Publish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No faqs found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(faqs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchFAQs(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="faq-modal" id="faq-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addFAQ()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Question<span class="text-danger">*</span></label>
                           <b-form-input v-model="faq.question" :class="{ 'is-invalid': Boolean(errors.question) }"></b-form-input>

                           <div v-for="(val, index) in errors.question" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="12" class="form-group">
                           <label class="control-label">Answer<span class="text-danger">*</span></label>
                           <textarea class="form-control" rows="5" v-model="faq.answer" :class="{ 'is-invalid': Boolean(errors.answer) }"></textarea>

                           <div v-for="(val, index) in errors.answer" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('faq-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
